export default {"src":"/_next/static/media/idCardIcon.0b0ab8c0.svg","height":44,"width":44};